export const EMBRACE_USER_STORAGE_KEY_DEPRECATED = 'embrace_user';
export const EMBRACE_USER_ID_STORAGE_KEY = 'embrace_user_id';
export const EMBRACE_EXTERNAL_USER_ID_KEY = 'embrace_external_user_id';
